(function () {
  "use strict";

  var submenus = document.querySelectorAll(".mol-submenu");

  submenus.forEach((el, i) => {
    var viewport = submenus[i].querySelector(".submenu-viewport");
    var list = submenus[i].querySelector(".submenu-list");
    var prevLink = submenus[i].querySelector(".submenu-prev");
    var nextLink = submenus[i].querySelector(".submenu-next");

    if (!viewport || !list || !prevLink || !nextLink) return;

    prevLink.addEventListener("click", function (e) {
      viewportScrollTo(-100);
    });

    nextLink.addEventListener("click", (event) => {
      viewportScrollTo(100);
    });

    viewport.addEventListener("scroll", function (e) {
      var x = this.scrollLeft;
      var w = this.scrollWidth - this.offsetWidth;

      prevLink.classList.toggle("inactive", x <= 0);
      nextLink.classList.toggle("inactive", x >= w);
    });

    window.addEventListener("load", viewportRecalculate);
    window.addEventListener("resize", viewportRecalculate);

    function viewportScrollTo(scrollDiff) {
      viewport.scrollTo({
        left: viewport.scrollLeft + scrollDiff,
        behavior: "smooth",
      });
    }

    function viewportRecalculate() {
      var lw = list.offsetWidth;
      var vw = viewport.scrollWidth;

      prevLink.classList.toggle("inactive", lw >= vw);
      nextLink.classList.toggle("inactive", lw >= vw);

      viewport.dispatchEvent(new Event("scroll"));
    }
  });
})();
